import { useState } from "react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { ChevronDown } from "lucide-react";
import { CategoryDropdown } from "../Category-dropdown"; // Adjust import path as needed
import { useTranslation } from "react-i18next";

const CategoriesDropdown = () => {
  const [openCategories, setOpenCategories] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="hidden md:flex items-center">
      <Popover open={openCategories} onOpenChange={setOpenCategories}>
        <PopoverTrigger asChild>
          <div className=" cursor-pointer flex items-center gap-2 px-4  text-gray-700 hover:text-red-600 transition-all duration-200 font-medium">
            {t("categories")}
            <ChevronDown size={16} />
          </div>
        </PopoverTrigger>
        <PopoverContent className="w-screen">
          <CategoryDropdown
            onSelect={() => setOpenCategories(false)}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default CategoriesDropdown;